import { compose, hoistStatics, lifecycle, withHandlers, withState } from 'recompose';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import KBCategory from './KBCategory';
import KbPostCategoryService from '../../../../services/kbPostCategory.service';


const goToPage = props => async (nextPage) => {
  const { categories,
    isLoad,
    categoriesCriteria,
    setCategoriesCriteria,
    setCategories,
    setCategoriesCount,
    setHasMore,
    categoriesCount,
  } = props;
  if (!isLoad) {
    const page = nextPage > -1 ? nextPage : 0;
    if (categoriesCriteria.limit * (page + 1) >= categoriesCount) setHasMore(false);
    const { data, count } = await KbPostCategoryService.getData({ ...categoriesCriteria, page });
    setCategories([...categories, ...data]);
    setCategoriesCount(count);
    setCategoriesCriteria({ ...categoriesCriteria, page });
  }
};

const chooseCategory = props => async (e, category) => {
  const { setActiveCategory, postsCriteria, setPostsCriteria, setShowBack } = props;
  e.preventDefault();
  setPostsCriteria({
    ...postsCriteria,
    category_id: category.id,
    page: 0,
  });
  setShowBack(true);
  setActiveCategory(category);
};

const defaultCriteria = {
  sortBy: 'created_at',
  order: 'desc',
  page: 0,
  limit: 9,
};


const enhance = compose(
  connect(null, null),
  withState('categories', 'setCategories', []),
  withState('categoriesCriteria', 'setCategoriesCriteria', defaultCriteria),
  withState('categoriesCount', 'setCategoriesCount', 0),
  withState('hasMore', 'setHasMore', true),
  withState('isLoad', 'setIsLoad', true),
  lifecycle({
    async componentDidMount() {
      const { setCategories, categoriesCriteria, setCategoriesCount, setIsLoad, setHasMore } = this.props;
      const { data, count } = await KbPostCategoryService.getData(categoriesCriteria);
      setCategoriesCount(count);
      setCategories(data);
      setHasMore(categoriesCriteria.limit < count);
      setIsLoad(false);
    },
  }),
  withHandlers({
    chooseCategory,
    goToPage,
  }),
);

export default withRouter(hoistStatics(enhance)(KBCategory));



// WEBPACK FOOTER //
// ./src/views/modules/kb/kbCategoryList/index.js